import { render, staticRenderFns } from "./WeCircularFooter.vue?vue&type=template&id=211b2ea0&scoped=true"
import script from "./WeCircularFooter.vue?vue&type=script&lang=js"
export * from "./WeCircularFooter.vue?vue&type=script&lang=js"
import style0 from "./WeCircularFooter.vue?vue&type=style&index=0&id=211b2ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211b2ea0",
  null
  
)

export default component.exports